import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#marker-pseudo}
 */
export class Marker extends PseudoElementSelector {
    static of() {
        return new Marker();
    }
    constructor() {
        super("marker");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (Marker) {
    Marker.parse = PseudoElementSelector.parseNonLegacy("marker", Marker.of);
})(Marker || (Marker = {}));
//# sourceMappingURL=marker.js.map